<body>
    <app-header [username]="username"></app-header>
    <div class="body-section">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</body>
